module.exports = __webpack_public_path__ + "static/media/Wellness05.0a967132.jpeg";